export default __webpack_public_path__ + "static/media/Calendar-icon.c527234b.svg";